import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredInspectionResultss,
  selectInspectionResultsLoading,
} from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { fetchInspectionResultsData } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { actions as inspectionResultsActions } from './store/slice';

const { setSelectedPart, clearDeepLink } = inspectionResultsActions;

const { INSPECTIONRESULTS_ADD_EDIT } = MODAL_TYPES;

const InspectionResultsTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredInspectionResultss(state),
    isLoading: selectInspectionResultsLoading(state),
  }));

  const handleEditClick = (e, record) => {
    e.stopPropagation();
    dispatch(clearDeepLink());
    dispatch(fetchInspectionResultsData({ 
      inspectionresults: record, 
      pageNumber: 1, 
      pageSize: 10 
    }));
    dispatch(setSelectedPart(record));
  };

  const handleDeleteClick = id => {
    // dispatch(deleteinspectionResultss(id));
  };

  const handleCheckboxChange = (e, record) => {
    // Handle checkbox change logic here
    console.log('Checkbox changed', record, e.target.checked);
  };

  const columns = [
    {
      title: 'Part ID',
      dataIndex: 'id',
      sorter: (a, b) => a.id.length - b.id.length,
    },
    {
      title: 'Part Number',
      dataIndex: 'partNumber',
      sorter: (a, b) => a.partNumber.length - b.partNumber.length,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      sorter: (a, b) => a.inspectionResults.length - b.inspectionResults.length,
    },

    {
      title: 'Actions',
      dataIndex: 'inspectionResultsId',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action justify-content-start">
            <Link className="me-2 p-2" onClick={e => handleEditClick(e, record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.inspectionResultsId)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default InspectionResultsTable;
